import PropTypes from 'prop-types'
import React, { useState } from 'react'
import config from 'SRC/config/config.json'
import Router from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import { Notification } from 'react-notification'

export const PaidAd = ({ name, surname, code, packageName, packageCost, packageDuration, promoRequest }) => {
  const { t, lang } = useTranslation('common')

  const [bankartError, setBankartError] = useState('')
  const [bankartLoading, setBankartLoading] = useState(false)

  const handlePayment = async () => {
    window.location.href = `${lang === 'me' ? '' : `/${lang}`}/online-payment/${promoRequest}`
  }

  return (
    <React.Fragment>
      <div className='registracija-content-tip' key='message'>
        <h3>{t('Izabrali ste')} &quot;{packageName}&quot;</h3>

        <Trans
          i18nKey='common:paid_ad_notification'
          components={{
            p: <p />,
            strong: <strong />
          }}
          values={{ packageDuration, packageCost, code }}
          defaultTrans={`
          <p>Da bi Vaš oglas u trajanju od <strong>{{packageDuration}} dana</strong> bio izdvojen ispred besplatnih oglasa
          na <strong>NASLOVNOJ</strong> strani i strani <strong>KATEGORIJE</strong> sa oznakom <strong>"Plaćen
          oglas"</strong>, potrebno je da uplatite <strong>{{packageCost}}€</strong> na žiro
          račun <strong>510-87720-41</strong> firme <strong>WebLab d.o.o. Bar</strong> sa svrhom uplate <strong>Šifra
          oglasa: {{code}}</strong>
          </p>
        `}
        />
      </div>

      {config.ckbPaymentEnabled ? <div className='bank-transfer-link'>
        {/* <h1>{t('ONLINE PLAĆANJE - PLATITE ODMAH BANKOVNOM KARTICOM')}</h1> */}
        <h1>{t('ckbpayment_head')}</h1>
        {/* <p>Klikom na dugme PLATI ODMAH bićete preusmjereni na sajt banke gdje možete obaviti sigurno plaćanje.</p> */}
        <p>{t('ckbpayment_text')}</p>
        <div className='bank-transfer-link__cards'>
          <img width={64} src='/icons/visa_pos_fc.png' />
          <img width={64} src='/icons/mc_vrt_opt_pos_63_3x.png' />
          <img width={64} src='/icons/ms_vrt_opt_pos_73_3x.png' />
          <img width={50} src='/icons/mc_idcheck_vrt_pos.png' />
          <img width={50} src='/icons/visa-secure_blu_72dpi.jpg' />
          <img width={120} src='/icons/Logo_NLB_Banka_sponzorski_10mm_RGB.png' />
        </div>

        <button onClick={bankartLoading ? null : handlePayment} disabled={bankartLoading} style={{ cursor: bankartLoading ? 'not-allowed' : 'pointer', marginTop: '5px' }}>
          {t('PLATI ODMAH')}
        </button>
      </div> : null}

      <div className='registracija-content-uplatnica' key='invoice'>
        <h3>{t('Primjer uplatnice za plaćanje iz banke ili pošte')}</h3>
        <div className='half'>
          <div className='polje'>
            <div className='polje-inner'>{name} {surname}</div>
            <div className='polje-info'>({t('Naziv inicijatora kao nalogodavca')})</div>
          </div>
          <div className='polje'>
            <div className='polje-inner'>{t('Šifra oglasa')}: {code}</div>
            <div className='polje-info'>({t('Svrha transfera')})</div>
          </div>
          <div className='polje'>
            <div className='polje-inner'>WebLab d.o.o. Bar</div>
            <div className='polje-info'>({t('Naziv korisnika')})</div>
          </div>
          <div className='polje'>
            <div className='polje-inner-no-border' />
            <div className='polje-info'>({t('Pečat i potpis inicijatora')})</div>
          </div>
        </div>
        <div className='half'>
          <div className='polje'>
            <div className='polje-inner' />
            <div className='polje-info'>({t('Broj računa inicijatora')})</div>
          </div>
          <div className='polje-small'>
            <div className='polje-inner' />
            <div className='polje-info'>({t('model')})</div>
          </div>
          <div className='polje-wide'>
            <div className='polje-inner' />
            <div className='polje-info'>({t('Poziv na broj zaduženja')})</div>
          </div>
          <div className='polje-label'>EUR</div>
          <div className='polje-iznos'>
            <div className='polje-inner'>{packageCost}</div>
            <div className='polje-info'>({t('Iznos')})</div>
          </div>
          <div className='polje-sifra'>
            <div className='polje-inner' />
            <div className='polje-info'>({t('Šifra transfera')})</div>
          </div>
          <div className='polje polje-broj-racuna'>
            <div className='polje-inner'>510-87720-41</div>
            <div className='polje-info'>({t('Broj računa korisnika')})</div>
          </div>
          <div className='polje-small'>
            <div className='polje-inner' />
            <div className='polje-info'>({t('model')})</div>
          </div>
          <div className='polje-wide'>
            <div className='polje-inner' />
            <div className='polje-info'>({t('Poziv na broj odobrenja')})</div>
          </div>
          <div className='polje-half polje-half-first'>
            <div className='polje-inner-no-border' />
            <div className='polje-info'>({t('Potpis primaoca')})</div>
          </div>
          <div className='polje-half'>
            <div className='polje-inner-no-border' />
            <div className='polje-info'>({t('Datum valute')})</div>
          </div>
          <div className='polje'>
            <div className='polje-inner-no-border' />
            <div className='polje-info'>({t('Mjesto i datum podnošenja')})</div>
          </div>
        </div>
      </div>

      <Notification
        isActive={Boolean(bankartError)}
        message={bankartError || ``}
        action={'Sakrij'}
        onClick={() => setBankartError('')}
      />
    </React.Fragment>
  )
}

PaidAd.propTypes = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  packageCost: PropTypes.number.isRequired,
  packageDuration: PropTypes.number.isRequired,
  packageName: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
  promoRequest: PropTypes.number.isRequired
}
